(function () {
  'use strict';

  var COPY = {
    en: {
      date: ['Enter your birth date', 'Step 1 of 3 · about one minute'],
      time_status: ['Choose your birth-time accuracy', 'Step 2 of 3 · exact, approximate, or unknown'],
      time_value: ['Enter the closest birth time', 'Step 2 of 3 · use your birth record if available'],
      place: ['Choose your birthplace', 'Step 3 of 3 · select a city suggestion'],
      ready: ['Create My Birth Chart', 'Free · no account or email'],
      preparing: ['Preparing your calculator…', 'Your chart is almost ready']
    },
    tr: {
      date: ['Doğum tarihini gir', '1/3 · yaklaşık bir dakika'],
      time_status: ['Doğum saati doğruluğunu seç', '2/3 · tam, yaklaşık veya bilinmiyor'],
      time_value: ['Bildiğin en yakın saati gir', '2/3 · varsa doğum kaydını kullan'],
      place: ['Doğum yerini seç', '3/3 · şehir önerilerinden birini seç'],
      ready: ['Doğum Haritamı Oluştur', 'Ücretsiz · hesap veya e-posta yok'],
      preparing: ['Hesaplayıcı hazırlanıyor…', 'Haritan neredeyse hazır']
    },
    es: {
      date: ['Introduce tu fecha de nacimiento', 'Paso 1 de 3 · cerca de un minuto'],
      time_status: ['Elige la precisión de la hora', 'Paso 2 de 3 · exacta, aproximada o desconocida'],
      time_value: ['Introduce la hora más cercana', 'Paso 2 de 3 · usa tu registro si lo tienes'],
      place: ['Elige tu lugar de nacimiento', 'Paso 3 de 3 · selecciona una sugerencia'],
      ready: ['Crear mi carta natal', 'Gratis · sin cuenta ni email'],
      preparing: ['Preparando la calculadora…', 'Tu carta está casi lista']
    },
    de: {
      date: ['Gib dein Geburtsdatum ein', 'Schritt 1 von 3 · etwa eine Minute'],
      time_status: ['Wähle die Genauigkeit der Geburtszeit', 'Schritt 2 von 3 · genau, ungefähr oder unbekannt'],
      time_value: ['Gib die ungefähre Geburtszeit ein', 'Schritt 2 von 3 · nutze wenn möglich deine Urkunde'],
      place: ['Wähle deinen Geburtsort', 'Schritt 3 von 3 · wähle einen Ortsvorschlag'],
      ready: ['Mein Geburtshoroskop erstellen', 'Gratis · kein Konto, keine E-Mail'],
      preparing: ['Rechner wird vorbereitet…', 'Dein Horoskop ist fast fertig']
    },
    pt: {
      date: ['Informe a data de nascimento', 'Passo 1 de 3 · cerca de um minuto'],
      time_status: ['Escolha a precisão da hora', 'Passo 2 de 3 · exata, aproximada ou desconhecida'],
      time_value: ['Informe a hora mais próxima', 'Passo 2 de 3 · use o registo se estiver disponível'],
      place: ['Escolha o local de nascimento', 'Passo 3 de 3 · selecione uma sugestão'],
      ready: ['Criar o meu mapa astral', 'Grátis · sem conta nem e-mail'],
      preparing: ['Preparando a calculadora…', 'O seu mapa está quase pronto']
    }
  };

  function language() {
    var code = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return COPY[code] ? code : 'en';
  }

  function track(name, payload) {
    var event = { event: name, tool: 'birth-chart-calculator', component_version: 'form-sticky-v1' };
    payload = payload || {};
    for (var key in payload) event[key] = payload[key];
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(event);
    } catch (_) {}
  }

  function isValidDate(input) {
    var value = input && input.value;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value || ''))) return false;
    var parts = value.split('-');
    var date = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    return date.getFullYear() === +parts[0] && date.getMonth() === +parts[1] - 1 && date.getDate() === +parts[2] && date <= new Date();
  }

  function isValidTime(input) {
    var match = /^(\d{2}):(\d{2})$/.exec(String(input && input.value || ''));
    return !!(match && +match[1] < 24 && +match[2] < 60);
  }

  function elementVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    return rect.top >= 64 && rect.bottom <= window.innerHeight - 76;
  }

  function focusTarget(target) {
    if (!target) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); } catch (_) { target.scrollIntoView(); }
    window.setTimeout(function () {
      try { target.focus({ preventScroll: true }); } catch (_) { try { target.focus(); } catch (__) {} }
    }, reduced ? 0 : 360);
  }

  function init(sticky) {
    if (!sticky || sticky.getAttribute('data-bch-ready') === 'true') return;
    var root = document.getElementById(sticky.getAttribute('data-bch-root'));
    var button = sticky.querySelector('button');
    var title = sticky.querySelector('[data-bch-form-sticky-title]');
    var note = sticky.querySelector('[data-bch-form-sticky-note]');
    if (!root || !button || !title || !note) return;
    sticky.setAttribute('data-bch-ready', 'true');

    var text = COPY[language()];
    var guide = root.querySelector('[id^="bchGuide-"]');
    var result = root.querySelector('[id^="bchResult-"]');
    var loading = root.querySelector('[id^="bchLoading-"]');
    var date = root.querySelector('input.da-date-input__native') || root.querySelector('input[data-birth]');
    var time = root.querySelector('[id^="bchTime-"]');
    var city = root.querySelector('[id^="bchCity-"]');
    var placeOk = root.querySelector('[id^="bchPlaceOk-"]');
    var calc = root.querySelector('[id^="bchCalcBtn-"]');
    var firstDate = root.querySelector('input[autocomplete="bday-month"]') || date;
    var firstTime = root.querySelector('input[name^="bchTimeStatus-"]');
    var shown = {};
    var submitting = false;
    var frame = 0;

    function formState() {
      if (submitting || (calc && calc.disabled)) return { key: 'preparing', target: calc, step: 4 };
      if (!isValidDate(date)) return { key: 'date', target: firstDate, step: 1 };
      var selected = root.querySelector('input[name^="bchTimeStatus-"]:checked');
      if (!selected) return { key: 'time_status', target: firstTime, step: 2 };
      if (selected.value !== 'unknown' && !isValidTime(time)) return { key: 'time_value', target: time, step: 2 };
      if (!city || !city.value.trim() || !placeOk || placeOk.classList.contains('bch-hidden')) return { key: 'place', target: city, step: 3 };
      return { key: 'ready', target: calc, step: 4 };
    }

    function setVisible(visible, state) {
      sticky.classList.toggle('is-on', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible) document.body.classList.add('bch-form-sticky-on');
      else if (!document.querySelector('.bch-form-sticky.is-on')) document.body.classList.remove('bch-form-sticky-on');
      if (visible && !shown[state.key]) {
        shown[state.key] = true;
        track('birth_chart_mobile_sticky_viewed', { sticky_state: state.key, form_step: state.step });
      }
    }

    function update() {
      frame = 0;
      if (submitting && guide && !guide.classList.contains('bch-hidden') && (!result || result.classList.contains('bch-hidden')) && (!loading || loading.classList.contains('bch-hidden')) && calc && !calc.disabled) submitting = false;
      var state = formState();
      var copy = text[state.key] || text.date;
      title.textContent = copy[0];
      note.textContent = copy[1];
      button.setAttribute('aria-label', copy[0] + '. ' + copy[1]);
      button.setAttribute('data-bch-state', state.key);
      button.disabled = state.key === 'preparing';
      var mobile = window.matchMedia ? window.matchMedia('(max-width: 899px)').matches : window.innerWidth < 900;
      var guideReady = guide && !guide.classList.contains('bch-hidden');
      var resultHidden = !result || result.classList.contains('bch-hidden');
      var loadingHidden = !loading || loading.classList.contains('bch-hidden');
      var rect = guide && guide.getBoundingClientRect();
      var reached = !!(rect && rect.top < window.innerHeight - 72 && rect.bottom > 88);
      var suggesting = root.classList.contains('bch-city-suggesting');
      // The form is one screen: only point to the next field when it is out of view.
      var targetVisible = elementVisible(state.key === 'ready' ? calc : state.target);
      setVisible(!!(mobile && guideReady && resultHidden && loadingHidden && reached && !suggesting && !targetVisible), state);
    }

    function schedule() {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }

    button.addEventListener('click', function () {
      var state = formState();
      if (state.key === 'preparing') return;
      sticky.setAttribute('data-bch-last-action', state.key);
      track('birth_chart_mobile_sticky_clicked', { sticky_state: state.key, form_step: state.step });
      if (state.key === 'ready' && calc) {
        submitting = true;
        sticky.setAttribute('data-bch-submit-forwarded', 'true');
        schedule();
        calc.click();
        window.setTimeout(function () {
          if (guide && !guide.classList.contains('bch-hidden') && !calc.disabled) submitting = false;
          schedule();
        }, 700);
        return;
      }
      focusTarget(state.target);
    });

    root.addEventListener('input', schedule, true);
    root.addEventListener('change', schedule, true);
    root.addEventListener('click', schedule, true);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule, { passive: true });
      window.visualViewport.addEventListener('scroll', schedule, { passive: true });
    }
    if (window.MutationObserver) new MutationObserver(schedule).observe(root, { subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-expanded'] });
    update();
  }

  function boot() {
    var stickies = document.querySelectorAll('.bch-form-sticky[data-bch-root]');
    for (var i = 0; i < stickies.length; i++) init(stickies[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
